//@flow
import { graphql } from 'react-relay';
import { generateMutation } from './generateMutation';
import type { OutputType } from './generateMutation';

const mutation = graphql`
    mutation profileMediaMutation($input: FirmDesignProfileMediaMutationInput!) {
        firmDesignProfileMediaMutation(input: $input) {
            tradeFirm {
                publicProfile {
                    profilePhoto
                    profilePhotoId
                    splashPhoto
                    splashPhotoId
                }
            }
        }
    }
`;

export type Args = {|
    serviceId: string,
    profilePhotoId: string,
    splashPhotoId: string,
|};

export const profileMediaMutation: (Object, Args) => Promise<OutputType> = generateMutation(
    mutation
);
